import {lazy, Suspense} from 'react';

const LazyReportAlert = lazy(() => import('components/ReportAlert/ReportAlert'));

const ReportAlert = props => (
  <Suspense fallback={null}>
    <LazyReportAlert {...props} />
  </Suspense>
);

export default ReportAlert;
